export class StudyModelRequest{
    "studyId":Number;
    "userId":Number;
}